import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import { episodeDetail, episodeList, programBoardList, boardDetail } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import useContent from '@/localization/data_export';
import { CommonLatest, CommonPopular, CommonRecommand } from './common/CommonVod';
import CommonVideo from '../common/common_video';
import './css/vod_view.scss';

function VodView(props) {
  const { mode, location } = props;

  const boardCustomType = useContent('boardCustomType');

  const today = dayjs.tz().format('YYYY-MM-DD');
  const ago7Day = dayjs.tz().subtract(7, 'day').format('YYYY-MM-DD');
  const ago14Day = dayjs.tz().subtract(14, 'day').format('YYYY-MM-DD');

  const epiPost = {
    lan_code: mode,
    is_news_allow: false,
    start_reg_date: ago7Day,
    end_reg_date: today,
    page_info: { row_count: 10, number: 0 },
  };

  const popularEpiPost = {
    lan_code: mode,
    is_news_allow: false,
    start_reg_date: ago14Day,
    end_reg_date: today,
    is_hit_count: true,
    page_info: { row_count: 5, number: 0 },
  };

  const [epiList, setEpiList] = useState([]);
  const [recoList, setRecoList] = useState([]);
  const [epiDetail, setEpiDetail] = useState([]);
  const [popularDetail, setPopularDetail] = useState([]);
  const [recoData] = useState({
    lan_code: mode,
    board_item_type: 'episode',
    title: '',
    content_category: '',
    event_category: null,
    is_open_allow: true,
    is_blind_allow: false,
    col_order: 'desc',
    page_info: { row_count: 5, number: 0 },
  });
  const [detailSave, setDetailSave] = useState([]);

  const [getEpiItem] = useAxios(episodeList, [], epiPost, true);
  const [getEpiPopular] = useAxios(episodeList, [], popularEpiPost, true);

  const [getEpiDetail, epiDetailRefetch] = useAxios(episodeDetail, [], {}, false);
  const [getEpiPopularDetail, epiPopularDetailRefetch] = useAxios(episodeDetail, [], {}, false);

  const [recoItem, recoItemRefetch] = useAxios(programBoardList, [], {}, false);
  const [recoDetail, recoDetailRefetch] = useAxios(boardDetail, [], {}, false);
  const [detailItem, setDetailRefetch] = useAxios(episodeDetail, [], {}, false);

  const { data: epiData } = getEpiItem;
  const { data: epiPopularList } = getEpiPopular;

  const { data: epiDetailData } = getEpiDetail;
  const { data: popularDetailData } = getEpiPopularDetail;

  const { data: recommendList } = recoItem;
  const { data: recoDetailList } = recoDetail;
  const { data: detailData } = detailItem;

  const setBoardCustomBoardId = async () => {
    await boardCustomType.csv.forEach((v) => {
      if (parseInt(v.type) === 31) {
        recoItemRefetch({
          ...recoData,
          board_id: parseInt(v.id),
        });
        recoDetailRefetch({ board_id: parseInt(v.id) });
      }
    });
  };

  useEffect(() => {
    if (boardCustomType) setBoardCustomBoardId();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (epiData) {
      epiData.item.forEach((data) => epiDetailRefetch({ episode_id: data.episode_id }));
      setEpiList([...epiData.item]);
    }
  }, [epiData]);

  useEffect(() => {
    if (epiPopularList) epiPopularList.item.forEach((data) => epiPopularDetailRefetch({ episode_id: data.episode_id }));
  }, [epiPopularList]);

  useEffect(() => {
    if (epiDetailData) setEpiDetail((prev) => [...prev, epiDetailData]);
  }, [epiDetailData]);

  useEffect(() => {
    if (popularDetailData) setPopularDetail((prev) => [...prev, popularDetailData]);
  }, [popularDetailData]);

  useEffect(() => {
    if (recommendList) {
      setRecoList([...recommendList.item]);
      recommendList?.item.forEach((v) => {
        setDetailRefetch({
          episode_id: v.episodes?.[0]?.episode_id,
        });
      });
    }
  }, [recommendList]);

  useEffect(() => {
    if (detailData) setDetailSave([...detailSave, detailData]);
  }, [detailData]);

  return (
    <div id="VodView" className="vodView">
      <section className="vodView_section">
        <CommonVideo mode={mode} />
      </section>
      <section className="vodView_section clip">
        <h2 className="title">
          Latest <em className="style-font">VOD</em>
        </h2>
        <CommonLatest episode={epiList} detailData={epiDetail} />
      </section>
      <section className="vodView_section popular">
        <div className="popularWrap">
          <h2 className="title">
            Most <em className="style-font">Popular</em>
          </h2>
          <CommonPopular epiPopular={epiPopularList} detailData={popularDetail} page={0} />
        </div>
      </section>
      <section className="vodView_section clip">
        <h2 className="title">
          Recommended <em className="style-font">VOD&nbsp;</em>
          <em className="style-font_small">
            {mode === 'en' ? recoDetailList?.content[0].text : recoDetailList?.content[1].text}
          </em>
        </h2>
        <CommonRecommand recommendList={recoList} detailData={detailSave} page={0} />
      </section>
    </div>
  );
}

export default VodView;
